import { render, staticRenderFns } from "./hobbies-bubble10.vue?vue&type=template&id=445844f0&"
import script from "./hobbies-bubble10.vue?vue&type=script&lang=js&"
export * from "./hobbies-bubble10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports